<div [id]="buttonTooltip?.id" class="vw-scale width-fit-content fixed-pos-tooltip {{ additionalClasses }}">
  <a
    data-qa="app-button-a"
    class="aligned-row-container height-100pcnt button {{ bordersSquaredShape }} {{ type }} {{ size }}"
    [class.button-disabled]="disabled"
    [class.sq]="showIcon === 'only'"
    [class.row-gap-0p375]="showSpinner && spinnerButtonClicked"
    (click)="buttonClickEmitter()"
  >
    <div *ngIf="buttonTooltip?.showCondition" class="fms-tooltip fixed-pos-tooltip-container !top-[-1.7rem]">
      <div class="fms-tooltip-body w-max" [style.left]="buttonTooltip.xShift"> {{ buttonTooltip?.text }}</div>
    </div>
    <svg
      class="{{ iconSize }} centered-row-container flex00auto"
      *ngIf="iconName?.length && (showIcon === 'left' || showIcon?.includes('only'))"
    >
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
    <div class="text">
      <ng-content></ng-content>
    </div>
    <svg
      class="{{ iconSize }} centered-row-container flex00auto"
      *ngIf="iconName?.length && showIcon === 'right'">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
    <div #spinnerDiv
      *ngIf="showSpinner"
      [class.width-1]="spinnerButtonClicked"
      class="button-spinner-container"
    ></div>
  </a>
</div>
